var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx } from "react/jsx-runtime";
import styled from 'styled-components';
import { Box } from '..';
import { Colors } from '../../constants';
import { loading } from './animations';
export var StyledLoadingRectangle = styled.div(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  height: 12px;\n  width: 100%;\n  border-radius: 10px;\n  position: relative;\n  overflow: hidden;\n  background-color: ", "50;\n  &:before {\n    content: '';\n    display: block;\n    position: absolute;\n    left: -300px;\n    top: 0;\n    height: 100%;\n    border-radius: 10px;\n    width: 100%;\n    background: linear-gradient(to right, ", " 0%, rgba(256, 256, 256, 0.1) 100%);\n    animation: ", " 1200ms ease-in-out infinite;\n  }\n"], ["\n  height: 12px;\n  width: 100%;\n  border-radius: 10px;\n  position: relative;\n  overflow: hidden;\n  background-color: ", "50;\n  &:before {\n    content: '';\n    display: block;\n    position: absolute;\n    left: -300px;\n    top: 0;\n    height: 100%;\n    border-radius: 10px;\n    width: 100%;\n    background: linear-gradient(to right, ", " 0%, rgba(256, 256, 256, 0.1) 100%);\n    animation: ", " 1200ms ease-in-out infinite;\n  }\n"])), Colors.PURPLE_4, Colors.PURPLE_4, loading);
export var SkeletonRectangle = function (_a) {
    var style = _a.style, width = _a.width;
    return (_jsx(Box, __assign({ style: { width: width } }, { children: _jsx(Box, __assign({ flex: "1" }, { children: _jsx(StyledLoadingRectangle, { style: style }, void 0) }), void 0) }), void 0));
};
var templateObject_1;
//# sourceMappingURL=SkeletonRectangle.js.map